import { ICommunityState } from 'types';

export const initState: ICommunityState = {
  communitiesList: null,
  topCommunitiesList: null,
  topEmissionReductionsCommunitiesList: null,
  newCommunitiesList: null,
  communityById: null,
  community: null,
  communityStatements: null,
  communityPublications: null,
  communityEvents: null,
  communityMilestones: null,
  isCommunityLoading: false,
  favoriteCommunitiesList: null,
};
